import Head from "next/head"

export default function SEOTags({
    title = "LifeShack | AI-Powered Job Search",
    description = "AI that applies to jobs for you. Find your next job with LifeShack's AI-powered job search platform. Save time and get hired faster.",
    url = "https://www.lifeshack.com/",
    type = "website",
    image = "https://production-appsyncstack-companyimages307b450c-17ekd4vq0gwy6.s3.us-west-2.amazonaws.com/lifeshack_opengraph.png",
    noIndex = false,
    noFollow = false,
    structuredData = null,
}) {
    return (
        <Head>
            <title>{title}</title>
            <meta
                name="title"
                content={title}
            />
            <meta
                name="description"
                content={description}
            />
            <meta property="og:url" content={url} />
            <meta property="og:type" content={type} />
            <meta property="og:site_name" content="LifeShack" />
            <meta
                property="og:title"
                content={title}
            />
            <meta
                property="og:description"
                content={description}
            />
            <meta
                property="og:image"
                content={image}
            />
            <meta property="og:image:alt" content={title} />
            {
                (noIndex || noFollow) && (
                    <meta
                        name="robots"
                        content={noFollow ? "noindex, nofollow" : "noindex, follow"}
                    />
                )
            }
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:image:alt" content={title} />
            <link rel="canonical" href={url} />
            {structuredData && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(structuredData),
                    }}
                />
            )}
        </Head>
    )
}
